/* Luxstelle restock + search alerts (v2, 28 Oct 2026).
 * 1) On a sold-out product page, a box under the Sold out button lets the customer leave a phone
 *    number. The request goes to Make ("Restock alerts: sign-ups"), which keeps a waiting list;
 *    when the item is back in stock, Make sends a WhatsApp and an SMS.
 * 2) On a search page with no results, the same box lets the customer leave a phone number for
 *    the item they searched for. The request goes to Make ("Search requests: sign-ups"); once the
 *    search finds an in-stock product, Make sends a WhatsApp and an SMS.
 * Phone only (no email). Fail-safe: if anything goes wrong, the page simply shows no box.
 */
(function () {
  'use strict';
  if (window.__lxRestock) return;
  window.__lxRestock = true;

  var HOOK = 'https://hook.eu1.make.com/82719i9e6s484tscgocfxupogdnhbglt';
  var SEARCH_HOOK = 'https://hook.eu1.make.com/u5tre3o12bxu6x2i3pkpesdwq9xg7vfs';
  var STORE_KEY = 'lx_restock_v1';
  var SEARCH_STORE_KEY = 'lx_search_v1';

  var TEXT = {
    title: 'Out of stock right now',
    body: "Leave your number and we'll message you on WhatsApp and SMS when it's back.",
    searchTitle: "Can't find what you're looking for?",
    searchBody: "Leave your number and we'll message you on WhatsApp and SMS when we have it.",
    phone: 'Phone number (WhatsApp)',
    button: 'Notify me',
    note: "We'll only use your number to tell you when this item is available.",
    badPhone: 'Please enter a Ghana mobile number, e.g. 024 123 4567.',
    sending: 'Saving…',
    done: "Done. We'll message you on WhatsApp and SMS when it's back.",
    searchDone: "Done. We'll message you on WhatsApp and SMS when we have it.",
    already: "You're on the list for this item. We'll message you on WhatsApp and SMS when it's back.",
    searchAlready: "You're on the list for this search. We'll message you on WhatsApp and SMS when we have it.",
    failed: "Sorry, that didn't go through. Please try again, or WhatsApp us on 055 920 0873."
  };

  /* ---------- helpers ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }
  // Ghana mobile number -> 233XXXXXXXXX, or '' if it is not one
  function normPhone(s) {
    var d = String(s || '').replace(/\D/g, '');
    if (d.indexOf('00233') === 0) d = d.slice(5);
    else if (d.indexOf('233') === 0 && d.length === 12) d = d.slice(3);
    else if (d.charAt(0) === '0') d = d.slice(1);
    return /^[25]\d{8}$/.test(d) ? '233' + d : '';
  }
  function loadDone(key) {
    try { return JSON.parse(localStorage.getItem(key) || '{}') || {}; } catch (e) { return {}; }
  }
  function saveDone(key, id, phone) {
    try {
      var d = loadDone(key);
      d[id] = phone;
      localStorage.setItem(key, JSON.stringify(d));
    } catch (e) { /* ignore */ }
  }

  var styled = false;
  function addStyle() {
    if (styled) return;
    styled = true;
    var css =
      '.lxrs{margin:14px 0 6px;padding:16px;border:1px solid rgba(var(--color-foreground,18,18,18),.18);border-radius:10px;background:rgba(var(--color-foreground,18,18,18),.03)}' +
      '.lxrs--search{max-width:52rem;margin:0 auto 3rem}' +
      '.lxrs[hidden]{display:none!important}' +
      '.lxrs__title{margin:0 0 4px;font-weight:600;font-size:1.6rem;line-height:1.3}' +
      '.lxrs__body{margin:0 0 12px;font-size:1.4rem;line-height:1.45;opacity:.8}' +
      '.lxrs .field{margin:0 0 10px}' +
      '.lxrs__msg{margin:10px 0 0;font-size:1.4rem;line-height:1.45}' +
      '.lxrs__msg--bad{color:rgb(var(--color-error,142,27,27))}' +
      '.lxrs__note{margin:10px 0 0;font-size:1.2rem;line-height:1.4;opacity:.65}' +
      '.lxrs__hp{position:absolute!important;left:-9999px!important;width:1px;height:1px;overflow:hidden}' +
      '.lxrs--done .lxrs__form{display:none}';
    var s = el('style');
    s.textContent = css;
    document.head.appendChild(s);
  }

  function field(id, type, label, autocomplete) {
    var f = el('div', 'field');
    var i = el('input', 'field__input');
    i.type = type;
    i.id = id;
    i.placeholder = ' ';
    i.setAttribute('autocomplete', autocomplete);
    if (type === 'tel') i.setAttribute('inputmode', 'tel');
    var l = el('label', 'field__label', label);
    l.setAttribute('for', id);
    f.appendChild(i);
    f.appendChild(l);
    return { wrap: f, input: i };
  }

  function buildBox(title, body, idSuffix) {
    var box = el('div', 'lxrs');
    box.hidden = true;
    box.appendChild(el('p', 'lxrs__title', title));
    var form = el('form', 'lxrs__form');
    form.setAttribute('novalidate', '');
    form.appendChild(el('p', 'lxrs__body', body));
    var phone = field('lxrs-phone' + idSuffix, 'tel', TEXT.phone, 'tel');
    var hp = el('input', 'lxrs__hp');
    hp.type = 'text';
    hp.name = 'company';
    hp.tabIndex = -1;
    hp.setAttribute('autocomplete', 'off');
    hp.setAttribute('aria-hidden', 'true');
    var btn = el('button', 'button button--full-width', TEXT.button);
    btn.type = 'submit';
    form.appendChild(phone.wrap);
    form.appendChild(hp);
    form.appendChild(btn);
    form.appendChild(el('p', 'lxrs__note', TEXT.note));
    var msg = el('p', 'lxrs__msg');
    msg.setAttribute('role', 'status');
    msg.setAttribute('aria-live', 'polite');
    msg.hidden = true;
    box.appendChild(form);
    box.appendChild(msg);
    return { box: box, form: form, phone: phone.input, hp: hp, btn: btn, msg: msg };
  }

  function say(ui, text, bad) {
    ui.msg.textContent = text;
    ui.msg.hidden = !text;
    ui.msg.classList.toggle('lxrs__msg--bad', !!bad);
  }

  function send(hook, data) {
    return fetch(hook, { method: 'POST', mode: 'no-cors', body: data, keepalive: true });
  }

  /* ---------- product page ---------- */
  function startProduct(product) {
    var pform = document.querySelector('.product__info-container product-form') ||
      document.querySelector('product-form');
    if (!pform) return;
    var idInput = pform.querySelector('input[name="id"]');
    addStyle();
    var ui = buildBox(TEXT.title, TEXT.body, '');
    pform.parentNode.insertBefore(ui.box, pform.nextSibling);

    var current = null;
    function selected() {
      var vid = idInput && idInput.value ? String(idInput.value) : '';
      if (!vid) {
        var q = location.search.match(/[?&]variant=(\d+)/);
        vid = q ? q[1] : '';
      }
      var v = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === vid) v = product.variants[i];
      }
      return v || product.variants[0];
    }
    function refresh() {
      var v = selected();
      if (!v) { ui.box.hidden = true; return; }
      if (current && String(current.id) === String(v.id)) return;
      current = v;
      ui.box.hidden = !!v.available;
      ui.box.classList.remove('lxrs--done');
      say(ui, '', false);
      ui.btn.disabled = false;
      if (!v.available && loadDone(STORE_KEY)[String(v.id)]) {
        ui.box.classList.add('lxrs--done');
        say(ui, TEXT.already, false);
      }
    }
    refresh();
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.name === 'id') setTimeout(refresh, 0);
    }, true);
    setInterval(refresh, 1000);

    ui.form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var v = current;
      if (!v || v.available) return;
      var phone = normPhone(ui.phone.value);
      if (!phone) { say(ui, TEXT.badPhone, true); try { ui.phone.focus(); } catch (e) { /* ignore */ } return; }
      if (ui.hp.value) { ui.box.classList.add('lxrs--done'); say(ui, TEXT.done, false); return; }
      var title = product.title + (v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : '');
      var url = 'https://luxstelle.com/products/' + product.handle + (product.variants.length > 1 ? '?variant=' + v.id : '');
      var data = new URLSearchParams();
      data.append('variant_id', String(v.id));
      data.append('product_id', String(product.id));
      data.append('title', title);
      data.append('url', url);
      data.append('phone', phone);
      data.append('email', '');
      ui.btn.disabled = true;
      say(ui, TEXT.sending, false);
      send(HOOK, data).then(function () {
        saveDone(STORE_KEY, String(v.id), phone);
        ui.box.classList.add('lxrs--done');
        say(ui, TEXT.done, false);
      }, function () {
        ui.btn.disabled = false;
        say(ui, TEXT.failed, true);
      });
    });
  }

  function initProduct(handle) {
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { if (p && p.variants && p.variants.length) startProduct(p); })
      .catch(function () { /* no box */ });
  }

  /* ---------- search page with no results ---------- */
  function searchQuery() {
    var m = location.search.match(/[?&]q=([^&]*)/);
    if (!m) return '';
    var q = '';
    try { q = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return ''; }
    q = q.replace(/\s+/g, ' ').trim();
    return q.length >= 2 && q.length <= 80 ? q : '';
  }
  function noResults() {
    var grid = document.querySelector('#product-grid ul.product-grid, .template-search__results ul.product-grid');
    if (grid) return grid.querySelectorAll('li').length === 0;
    return /\b0 results\b/i.test(document.title) || !!document.querySelector('.template-search--empty');
  }
  function startSearch(q) {
    var header = document.querySelector('.template-search__header');
    if (!header || !noResults()) return;
    addStyle();
    var ui = buildBox(TEXT.searchTitle, TEXT.searchBody.replace('we have it', 'we have “' + q + '”'), '-search');
    ui.box.classList.add('lxrs--search');
    header.parentNode.insertBefore(ui.box, header.nextSibling);
    ui.box.hidden = false;
    var key = q.toLowerCase();
    if (loadDone(SEARCH_STORE_KEY)[key]) {
      ui.box.classList.add('lxrs--done');
      say(ui, TEXT.searchAlready, false);
    }
    ui.form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var phone = normPhone(ui.phone.value);
      if (!phone) { say(ui, TEXT.badPhone, true); try { ui.phone.focus(); } catch (e) { /* ignore */ } return; }
      if (ui.hp.value) { ui.box.classList.add('lxrs--done'); say(ui, TEXT.searchDone, false); return; }
      var data = new URLSearchParams();
      data.append('query', q);
      data.append('phone', phone);
      data.append('source', 'search');
      ui.btn.disabled = true;
      say(ui, TEXT.sending, false);
      send(SEARCH_HOOK, data).then(function () {
        saveDone(SEARCH_STORE_KEY, key, phone);
        ui.box.classList.add('lxrs--done');
        say(ui, TEXT.searchDone, false);
      }, function () {
        ui.btn.disabled = false;
        say(ui, TEXT.failed, true);
      });
    });
  }

  function init() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (m) { initProduct(decodeURIComponent(m[1])); return; }
    if (/^\/search\/?$/.test(location.pathname)) {
      var q = searchQuery();
      if (q) startSearch(q);
    }
  }
  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (e) { /* no box */ }
})();
